module.exports = __webpack_public_path__ + "static/media/(V)-Prata-01.86378446.jpg";